import request from "@/request/index.js";
// 是否绑定了邀请人
export const toCheckUserBind = (params) =>
  request.post("/api/sszc/checkUserBind", params);
// 签名验证
export const toVerify = (params) => request.post("/api/demo/verify", params);
// 登录
export const toLogin = (params) => request.post("/api/user/toLogin", params);
export const accountLogin = (params) => request.post("/api/user/login", params);
export const accountRegister = (params) => request.post("/api/user/register", params);
export const accountLogout = () => request.post("/api/user/logout");
export const sendEmailCode = (params) => request.post("/api/ems/send", params);
export const accountStatus = () => request.get("/api/account/status");
export const saveAccountProfile = (params) => request.post("/api/account/saveProfile", params);
export const submitPassportKyc = (params) => request.post("/api/account/submitKyc", params);
export const bindLegacyWallet = (params) => request.post("/api/account/bindLegacyWallet", params);
// 首页
export const toHome = (params) => request.get("/api/sszc/index", { params });
// 获取产品列表
export const toProduceList = (params) =>
  request.get("/api/sszc/product_list", { params });
// 获取配置项
export const toConfigs = (params) =>
  request.get("/api/sszc/getConfigs", { params });
// 获取产品详情
export const toProduceDetails = (params) =>
  request.get("/api/sszc/product_detail", { params });
// 下单
export const toPledge = (params) => request.post("/api/sszc/pledge", params);
// 下单回调
export const toPledgeBack = (params) =>
  request.post("/api/sszc/pledgeCallback", params);
// 获取产品类型
export const toProduceType = (params) =>
  request.get("/api/sszc/gettype", { params });
// 绑定邀请人
export const toBindUser = (params) =>
  request.post("/api/sszc/bindUser", params);

// KYC认证
export const toKycSubmit = (params) =>
  request.post("/api/sszc/mission", params);
// KYC认证回显,status 0 审核 1 通过 2 驳回
export const toKycShow = (params) =>
  request.post("/api/sszc/missionback", params);
// 是否认证了KYC,is_kyc  0 未申请 1 申请中 2 通过
export const toKycState = (params) =>
  request.post("/api/sszc/getUserinfo", params);

// 帮助文档列表
export const toHelpList = (params) =>
  request.get("/api/sszc/notice_list", params);
// 帮助文档列表详情
export const toHelpListDetails = (params) =>
  request.get(`api/sszc/notice_detail?id=${params}`);
export const toFooterConfigs = (params) =>
  request.get(`api/sszc/getFootConfigs`);

export const accountOrders = (params) => request.get('/api/account/orders', { params });
